import { Injectable } from '@angular/core';
import { DashboardApiService } from './dashboard.api.service';
import { Dashboard, CreateUpdateDashboardModel } from '../../models/dashboard';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DashboardDomainService {
    constructor(private dashboardApiService: DashboardApiService) { }

    getAllDashboards(): Observable<Dashboard[] | {}> {
        return this.dashboardApiService.getAllDashboards();
    }

    createDashboard(dashboard: CreateUpdateDashboardModel): Observable<string> {
        return this.dashboardApiService.createDashboard(dashboard);
    }

    updateDashboard(dashboard: CreateUpdateDashboardModel): Observable<any> {
        return this.dashboardApiService.updateDashboard(dashboard);
    }

    deleteDashboard(dashboardId: string): Observable<any> {
        return this.dashboardApiService.deleteDashboard(dashboardId);
    }

    deleteDashboardLogo(dashboardId: string): Observable<any> {
        return this.dashboardApiService.DeleteDashboardLogo(dashboardId);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/dashboard/dashboard.domain.service.ts